import { parseISO } from 'date-fns';

const PESQUISA_CLIMA_RESPOSTA_PATH = '/responder-pesquisa-clima';

export const FORMATO_EXIBICAO_FORMULARIO_GLOBAL = {
  PAGINA_UNICA: 1,
  PERGUNTA_POR_VEZ: 2,
};

export const TIPO_IDENTIFICACAO_FORMULARIO_GLOBAL = {
  CONFIDENCIAL: 1,
  ANONIMA: 2,
  IDENTIFICADA: 3,
};

export const TIPO_APLICACAO_FORMULARIO_GLOBAL = {
  UNICA: 1,
  RECORRENTE: 2,
};

export const TIPO_TERMINO_RECORRENCIA = {
  QUANTIDADE_APLICACOES: 1,
  DATA_ESPECIFICA: 2,
  SEM_DATA_TERMINO: 3,
};

export const SITUACAO_APLICACAO_FORMULARIO_GLOBAL = {
  VIGENTE: 1,
  ENCERRADA: 2,
  PREVISTA: 3,
};

export const getDataAplicacaoFormularioGlobal = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  return typeof value === 'string' ? parseISO(value) : new Date(value);
};

export const getLookupId = (value) =>
  Number(value?.id ?? value?.Id ?? value ?? 0);

export const getPesquisaClimaLink = (data) => {
  const link = data?.linkPesquisa;

  if (link) return link;

  const token = data?.token;

  if (!token) return '';

  return `${window.location.origin}${PESQUISA_CLIMA_RESPOSTA_PATH}/${token}`;
};

export const copyToClipboard = async (value) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return true;
  }

  const input = document.createElement('textarea');
  input.value = value;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(input);

  return copied;
};
